import {
  createApp
} from 'vue'
import App from './App.vue'
// import "bootstrap/dist/js/bootstrap.js"
// import "bootstrap/dist/js/bootstrap.bundle.min.js"
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import Keycloak from 'keycloak-js'
import 'balloon-css';
import router from './router'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  far
} from '@fortawesome/free-regular-svg-icons';
import {
  faUserSecret
} from '@fortawesome/free-solid-svg-icons'
import {
  dom
} from "@fortawesome/fontawesome-svg-core";
import { fab } from '@fortawesome/free-brands-svg-icons'
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import vueTheStorages from 'vue-the-storages'
import Notifications from '@kyvg/vue3-notification'
import {
  createStore
} from 'vuex'
import VueMultiselect from 'vue-multiselect'
import './assets/css/custom.css';
import './assets/css/style.css';
import './assets/css/style-responsive.css';
import CryptoJS from 'crypto-js';
import '@fortawesome/fontawesome-free/css/all.css'
import Sparkline from 'vue-sparklines'
import VueLazyload from 'vue-lazyload'
dom.watch()
library.add(faUserSecret, fas, far, fab)
var key = 'CanvasOpsigh@KEY'
var iv = CryptoJS.enc.Utf8.parse('Opsightencry@IVK')
const store = createStore({
  state() {
    return {
      nexSteps: false,
      TClrs: "darkTheme",
      AsgName: "",
      Is_bookmark: 'No',
      widgetCond: 0,
      isOwner: undefined,
      chartColor: JSON.parse(localStorage.getItem('widgetColors')) || ['#FFE57D', '#ffcc00'],
      storyBoard: JSON.parse(localStorage.getItem('myPresentationJson')) || [],
      gradientGreen: Object,
      getgradRed: Object,
      gradientOrange: Object,
      gradientYellow: Object,
      gradientCyan: Object,
      gradientBlue: Object,
      gradientPurple: Object,
      gradientOceanBlue: Object,
      gradientSandal: Object,
      gradientBrown: Object,
      gradientViolet: Object,
      gradientGrey: Object,
      assDetails: JSON.parse(localStorage.getItem('assDetails')) || {},
      isLiveDate: localStorage.getItem('isLiveDate') || null,
      APPMTowerData: localStorage.getItem('APPMTowerData') || [],
      ppmDataStore: localStorage.getItem('ppmDataStore') || undefined,
      isFromPermition: localStorage.getItem('isFromPermition') || undefined,
      pprIDForHistory: localStorage.getItem('pprIDForHistory') || undefined,
    }
  },
  mutations: {
    real_date(state, date){
      state.isLiveDate = date
    },
    store_widget(state, chartData){
      state.storyBoard = chartData
    },
    set_widget_color(state, colorData){
      state.chartColor = colorData
    },
    store_real(state, cond){
      state.assDetails = cond
    },
    navSteps(state, payload) {
      state.nexSteps = payload
      this.nexSteps = payload
    },
    getAsg(state, payload) {
      state.AsgName = payload.AsgName
      state.isOwner = payload.isOwner
      if (payload.Is_bookmark != '') {
        state.Is_bookmark = payload.Is_bookmark
      }
    },
    setWidgetCond(state, payload) {
      state.widgetCond = payload
    },
    APPMTowerData(state, tower) {
      state.APPMTowerData = JSON.stringify(tower)
    },
    ppmDataStore(state, data) {
      state.ppmDataStore = data
    },
    isFromPermition(state, data) {
      state.isFromPermition = data
    },
    pprIDForHistory(state, data) {
      state.pprIDForHistory = JSON.stringify(data)
    },
  },
  actions: {
      increment (context) {
        context.commit('increment')
      },
      setWidgetColor({commit}, color){
        localStorage.setItem('widgetColors', color)
        commit('set_widget_color', color)
      },
      storeWidget({commit}, widget){
        localStorage.setItem('myPresentationJson', widget)
        commit('store_widget', widget)
      },
      storeIsLive({commit}, real){
        localStorage.setItem('assDetails', real)
        commit('store_real', real)
      },
      storeIsDate({commit}, date){
        localStorage.setItem('isLiveDate', date)
        commit('real_date', date)
      },
      APPMTowerData({commit}, tower){
        localStorage.setItem('APPMTowerData', JSON.stringify(tower))
        commit('APPMTowerData', tower)
      },
      ppmDataStore({commit}, data){
        localStorage.setItem('ppmDataStore', data)
        commit('ppmDataStore', data)
      },
      isFromPermition({commit}, data){
        localStorage.setItem('isFromPermition', data)
        commit('isFromPermition', data)
      },
      pprIDForHistory({commit}, data){
        localStorage.setItem('pprIDForHistory', JSON.stringify(data))
        commit('pprIDForHistory', data)
      },

    },
  getters: {
    getgradRed(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientRed = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientRed.addColorStop(0, 'rgba(253, 55, 56, 0.75)')
      state.gradientRed.addColorStop(1, 'rgba(253, 55, 56, 0.25)')
      return state.gradientRed
    },
    getgradOrange(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientOrange = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientOrange.addColorStop(0, 'rgba(247, 99, 12, 0.75)')
      state.gradientOrange.addColorStop(1, 'rgba(247, 99, 12, 0.25)')
      return state.gradientOrange
    },
    getgradYellow(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientYellow = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientYellow.addColorStop(0, 'rgba(255, 185, 0, 0.75)')
      state.gradientYellow.addColorStop(1, 'rgba(255, 185, 0, 0.25)')
      return state.gradientYellow
    },
    getgradCyan(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientCyan = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientCyan.addColorStop(0, 'rgba(75, 192, 192, 0.75)')
      state.gradientCyan.addColorStop(1, 'rgba(75, 192, 192, 0.1)')
      return state.gradientCyan
    },
    getgradBlue(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientBlue = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientBlue.addColorStop(0, 'rgba(54, 162, 235, 0.75)')
      state.gradientBlue.addColorStop(1, 'rgba(54, 162, 235, 0.1)')
      return state.gradientBlue
    },
    getgradPurple(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientPurple = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientPurple.addColorStop(0, 'rgba(136,23,152, 0.75)')
      state.gradientPurple.addColorStop(1, 'rgba(136,23,152, 0.1)')
      return state.gradientPurple
    },
    getgradOceanBlue(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientOceanBlue = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientOceanBlue.addColorStop(0, 'rgba(168, 192, 255, 0.75)')
      state.gradientOceanBlue.addColorStop(1, 'rgba(168, 192, 255, 0.1)')
      return state.gradientOceanBlue
    },
    getgradSandal(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientSandal = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientSandal.addColorStop(0, 'rgba(255, 216, 155, 0.75)')
      state.gradientSandal.addColorStop(1, 'rgba(255, 216, 155, 0.1)')
      return state.gradientSandal
    },
    getgradBrown(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientBrown = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientBrown.addColorStop(0, 'rgba(178, 159, 148, 0.75)')
      state.gradientBrown.addColorStop(1, 'rgba(178, 159, 148, 0.1)')
      return state.gradientBrown
    },
    getgradGreen(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientGreen = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientGreen.addColorStop(0, 'rgba(54, 191, 54, 0.75)')
      state.gradientGreen.addColorStop(1, 'rgba(54, 191, 54, 0.25)')
      return state.gradientGreen
    },
    getgradViolet(state) {
      var ctx = document.getElementById('samplecat').getContext("2d")
      state.gradientViolet = ctx.createLinearGradient(0, 0, 0, 250)
      state.gradientViolet.addColorStop(0, 'rgba(75, 19, 79, 0.75)')
      state.gradientViolet.addColorStop(1, 'rgba(75, 19, 79, 0.1)')
      return state.gradientViolet
    },
  }
})
const vueTheStoragesOptions = {
  sessionMirrorKey: '$sessionData',
  sessionStorageKey: '$session',
  options: {
    vueModule: null,
    strict: true,
    mirrorOperation: false,
    updateMirror: true
  }
}
const initOptions = {
  realm: 'opsightazure',
  clientId: 'OPSight_Client',
  url: "https://canvasopsight.ltimindtree.com/auth", // keycloak URL
  checkLoginIframe: false,
  "confidential-port": 0,
  "ssl-required": "external",
  'public-client': true,
  'verify-token-audience': false,
  onLoad: 'login-required'
}
const keycloak = Keycloak(initOptions);
axios.interceptors.request.use(function (config) {
  const allCookies = document.cookie;
  const cookieArray = allCookies.split('; ');
  let kcToken;
  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].split('=');
    if (cookie[0] === 'keycloakToken') {
      kcToken = cookie[1];
      break;
    }
  }
  config.headers['Authorization'] = 'Bearer ' + decodeURIComponent(kcToken)
  return config;
}, async function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  return response;
}, async function (error) {
  if (error.response) {
    if (error.response.status === 403) {
      // console.log(error)
      localStorage.clear();
      sessionStorage.clear();
      clearAllCookies();
      keycloak.logout();
    }
    if (error.response.status === 401) {
      alert('Kindly proceed login with Firstname[.]PSNUMBER[@]ltimindtree[.]com')
      localStorage.clear();
      sessionStorage.clear();
      clearAllCookies();
      keycloak.logout();
    }
    if (error.response.status === 504 || error.response.status === 503) {
      alert('504 Gateway Time-out. Kindly Contact Support Team.')
    }
    if (error.response.status === 406) {
      alert('This action is blocked from WAF(web application firewall) level. Kindly Contact Support Team.')
    }
  }else {
    console.error('Error setting up the request:', error.message);
  }
  return Promise.reject(error);
});
function instantiateVueApp() {
  const app = createApp(App)
  app.config.globalProperties.uriApiUrl = "/api/"
  app.config.globalProperties.$myPresentationJson = []
  app.config.globalProperties.enabledDebug = 0
  app.config.globalProperties.$keycloak = keycloak;
  app.component('widgeterror-component', {
    template: '<div class="alert errInfo"><h6>Chart Generation Failed. Click <u class="cursor-pointer mailLink" v-on:click="sendErr()">here</u> to report issue to Support Team or \n Retry Changing the Filters</h6></div>',
  })
  app.component('font-awesome-icon', FontAwesomeIcon)
    .component('VueMultiselect', VueMultiselect)
  app.use(SimpleTypeahead)
    .use(router)
    .use(VueAxios, axios)
    .use(vueTheStorages, vueTheStoragesOptions)
    .use(Notifications)
    .use(store)
    .use(Sparkline)
    .use(VueLazyload)
  app.provide('axios', app.config.globalProperties.axios)
  app.mount('#app')
  app.directive('hrstodaysmod', (el, binding) => {
    let pier = binding.value.val;
    pier = Math.round(pier);
    let hours = Math.floor(pier / 60);
    let minutes = pier % 60;
    let timeret = "";
    let isStop = false;
    if (hours > 0) {
      if (hours < 24) {
        timeret += hours + "<small>h</small> ";
      } else {
        var days = Math.floor(hours / 24);
        hours = hours - (days * 24);
        isStop = true;
        if (days > 100) {
          timeret += days + "<small>d</small>";
        } else {
          timeret += days + "<small>d</small> " + hours + "<small>h</small> ";
        }
      }
    }
    if (minutes > 0 && !isStop) {
      timeret += minutes + "<small>m</small> ";
    }
    if (timeret == "") {
      timeret = "< 1<small>min</small>"
    }
    el.innerHTML = timeret;
  })
}
function clearAllCookies() {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const cookieName = cookie.split("=")[0].trim();
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}


const windowUrl = new URL(window.location.href)
var params = new URLSearchParams(windowUrl.search)
let acTk = params.get('access_token');
let rfTK = params.get('refresh_token');

const cookieArray = document.cookie.split('; ');
let kcToken;
for (let i = 0; i < cookieArray.length; i++) {
  const cookie = cookieArray[i].split('=');
  if (cookie[0] === 'keycloakToken') {
    kcToken = cookie[1];
    break;
  }
}
const obj = {
  onLoad: initOptions.onLoad,
  //flow: 'implicit'
}
if(kcToken == undefined && (acTk != null || rfTK != null)){
  var parsedWordArray = CryptoJS.enc.Base64.parse(acTk);
  var access_token = parsedWordArray.toString(CryptoJS.enc.Utf8);

  var parsedWordArrayRF = CryptoJS.enc.Base64.parse(rfTK);
  var refresh_token = parsedWordArrayRF.toString(CryptoJS.enc.Utf8);

  obj.token=access_token;
  obj.refreshToken= refresh_token; 
  obj.checkLoginIframe= false;
}


//if(kcToken != undefined){
//  instantiateVueApp()
//}else{
keycloak.init(obj).then((auth) => {
  //console.log(auth)
  if (!auth) {
    window.location.reload();
  } else {
    //console.log("Authenticated");
  }
  instantiateVueApp()
  key = CryptoJS.enc.Utf8.parse(key);
  //console.log(keycloak.idToken)
  var encrypted = CryptoJS.AES.encrypt(keycloak.idToken, key, { iv: iv, mode: CryptoJS.mode.CBC});
  var encoded_keycloak =encrypted.toString();
  document.cookie = "keycloakToken="+encodeURIComponent(encoded_keycloak)+"; Secure= HttpOnly;SameSite=Strict;"
    // Get the current URL
    setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.delete('access_token');
      url.searchParams.delete('refresh_token');
      window.history.replaceState({}, '', url);
    }, 2000);

  keycloak.isTokenExpired = () => {
    keycloak.updateToken(70).then((refreshed) => {
      if (refreshed) {
          document.cookie = "keycloakToken="+encodeURIComponent(encoded_keycloak)+"; Secure= HttpOnly;SameSite=Strict;"
      } else {
        //   console.log('Token not refreshed, valid for ' +
        //  Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).catch((error) => {
      localStorage.clear();
      sessionStorage.clear();
      clearAllCookies()
      document.location.href = '/';
      //document.location.href = '/OPSight';
    });
  }
}).catch((error) => {
  localStorage.clear();
  sessionStorage.clear();
  keycloak.logout();
  });
//}
